"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactModal = _interopRequireDefault(require("react-modal"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _togaButton = _interopRequireDefault(require("@thinkific/toga-button"));

var _togaIcon = _interopRequireDefault(require("@thinkific/toga-icon"));

var _togaTypography = require("@thinkific/toga-typography");

var _ModalHeader = require("./ModalHeader");

var _ModalBody = require("./ModalBody");

var _ModalFooter = require("./ModalFooter");

var _Modal = _interopRequireDefault(require("./Modal.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cx = _bind["default"].bind(_Modal["default"]);

var Modal = /*#__PURE__*/function (_Component) {
  _inherits(Modal, _Component);

  var _super = _createSuper(Modal);

  function Modal(props) {
    var _this;

    _classCallCheck(this, Modal);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillReceiveProps", function (_ref) {
      var isOpen = _ref.isOpen;

      _this.setState({
        isOpen: isOpen
      });
    });

    _defineProperty(_assertThisInitialized(_this), "findComponent", function (children, componentToFind) {
      return Array.isArray(children) && children.find(function (component) {
        return component.type.name === componentToFind.name;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeModal", function () {
      var closeModal = _this.props.closeModal;

      _this.setState({
        isOpen: false
      });

      closeModal();
    });

    _this.state = {
      isOpen: props.isOpen
    };
    return _this;
  } // eslint-disable-next-line camelcase


  _createClass(Modal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          contentLabel = _this$props.contentLabel,
          extraClassNames = _this$props.extraClassNames,
          style = _this$props.style,
          title = _this$props.title,
          footer = _this$props.footer,
          isFullWidth = _this$props.isFullWidth;
      var isOpen = this.state.isOpen;
      return /*#__PURE__*/_react["default"].createElement(_reactModal["default"], {
        ariaHideApp: false,
        className: cx('modal', extraClassNames),
        contentLabel: contentLabel,
        isOpen: isOpen,
        overlayClassName: cx('overlay'),
        style: style,
        onRequestClose: this.closeModal
      }, this.findComponent(children, _ModalHeader.ModalHeader), title && /*#__PURE__*/_react["default"].createElement(_ModalHeader.ModalHeader, {
        hasTitle: !!title
      }, /*#__PURE__*/_react["default"].createElement(_togaTypography.H4, null, title), /*#__PURE__*/_react["default"].createElement(_togaButton["default"], {
        appearance: "knockout",
        "aria-label": "Close",
        className: cx('modal__header__close-button'),
        onClick: this.closeModal
      }, /*#__PURE__*/_react["default"].createElement(_togaIcon["default"], {
        name: "x-dismiss",
        "aria-hidden": true
      }))), this.findComponent(children, _ModalBody.ModalBody) || /*#__PURE__*/_react["default"].createElement(_ModalBody.ModalBody, {
        hasTitle: !!title,
        isFullWidth: isFullWidth
      }, children), this.findComponent(children, _ModalFooter.ModalFooter), footer && /*#__PURE__*/_react["default"].createElement(_ModalFooter.ModalFooter, null, footer(this.closeModal)));
    }
  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  /** Content for the modal */
  children: _propTypes["default"].node.isRequired,

  /** The action to close the modal, handled by the parent */
  closeModal: _propTypes["default"].func,

  /** Aria information about the modal */
  contentLabel: _propTypes["default"].string,

  /** Scape hatch to override classes, use sparingly */
  extraClassNames: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].string]),

  /** A render prop that recieves the closeModal func as the first parameter.
   * Use if you need to close the modal from here * */
  footer: _propTypes["default"].func,

  /** Removes the padding in the content so you can have the whole space available.
   * Usefull for videos and photos * */
  isFullWidth: _propTypes["default"].bool,

  /** Provide this to show/hide the modal * */
  isOpen: _propTypes["default"].bool,

  /** Another Scape hatch to override classes but for the react-modal, use sparingly */
  style: _propTypes["default"].object,

  /** The title on the header, is a H3 element */
  title: _propTypes["default"].node
};
Modal.defaultProps = {
  title: null,
  contentLabel: 'Modal',
  isOpen: false,
  closeModal: function closeModal() {},
  extraClassNames: null,
  style: {},
  footer: null,
  isFullWidth: false
};
var _default = Modal;
exports["default"] = _default;